export default __webpack_public_path__ + "static/media/Horsehair Blanket.bc4cb0ed.jpg";